import FormFieldViewText from "components/FormFields/ViewText";
import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import Banner from "ds/components/Banner";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import { Space } from "types/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

import { isOnOutsideClickElementInteractive } from "./helpers";
import styles from "./styles.module.css";

const EMPTY_VALUE_PLACEHOLDER = "-";

type SpaceDrawerViewProps = {
  space?: Space;
  isRootAdmin: boolean;
  onClose?: () => void;
  hideNotEditableBanner?: boolean;
};

const SpaceDrawerView = ({
  space,
  isRootAdmin,
  onClose,
  hideNotEditableBanner,
}: SpaceDrawerViewProps) => {
  const { spaces } = useTypedContext(SpacesContext);
  const parentSpaceDetails = spaces.find((s) => s.id === space?.parentSpace);

  return (
    <DrawerSimple
      onClose={onClose}
      shouldCloseOnInteractOutside={isOnOutsideClickElementInteractive}
    >
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Space details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody noPadding>
        <div className={styles.viewList}>
          {!hideNotEditableBanner && isRootAdmin && space && (
            <Banner variant="info">This is your {space?.name} space. It’s not editable.</Banner>
          )}

          <FormFieldViewText label="Name" value={space?.name} />
          <FormFieldViewText label="ID" value={space?.id} withCopy />

          <FormFieldViewText
            label="Description"
            value={space?.description}
            noTextEllipsis
            emptyPlaceholder={EMPTY_VALUE_PLACEHOLDER}
          />

          <FormField label="Parent space">
            {space?.parentSpace ? (
              <SpacePath
                variant="expandable"
                spaceId={space.parentSpace}
                fallbackName={parentSpaceDetails?.name}
              />
            ) : (
              <Typography tag="span" variant="p-body3" color="disabled">
                {EMPTY_VALUE_PLACEHOLDER}
              </Typography>
            )}
          </FormField>

          <FormField label="Labels">
            {space && space.labels.length > 0 ? (
              <TagsList tags={space.labels} alwaysExpanded />
            ) : (
              <Typography tag="span" variant="p-body3" color="disabled">
                {EMPTY_VALUE_PLACEHOLDER}
              </Typography>
            )}
          </FormField>
          <FormFieldViewText label="Inheritance" value={space?.inheritEntities ? "Yes" : "No"} />
        </div>
      </DrawerBody>
    </DrawerSimple>
  );
};

export default SpaceDrawerView;
